import React from 'react';

function Header(props) {
    return (
        <header className="text-white bg-primary-dark heading-block">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="heading-block__header">{props.title}</h1>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
